export const    Progress  = ({percentage}) => {
    console.log(percentage)
    return(
        <div className="progression-content">
            <div className="horizontal space-between"><p className="small-text">Progressie</p><p className="small-text bold-text primary-800">{percentage}%</p></div>
            <div className="progression-bar" style={{width:`${percentage}%`}}></div>
        </div>
    )
}